module.exports = __webpack_public_path__ + "img/visadebit.0eb14603.png";